class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    const productsInfiniteWrapper = document.querySelector('.product-grid-infinite-scrolling');
    if (productsInfiniteWrapper) {
      const productGridCustomElement = document.querySelector("product-grid");
      if (productGridCustomElement) {
        productGridCustomElement.handleInfiniteScrolling();
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    let menuDrawer = document.querySelector(".mobile-facets__wrapper");
    if(menuDrawer){
      menuDrawer.closeSubmenu(document.querySelector(".mobile-facets__disclosure"))
    }
  }
}

customElements.define('facet-remove', FacetRemove);

class MobileSorting extends HTMLElement {
  constructor(){
    super();
    this.mobileBottomFilter = document.querySelector(".mobile-bottom-filter");
    this.mobileBottomSort = document.querySelector(".mobile-bottom-sort");
    this.filterDrawer = document.querySelector('.mobile-facets__disclosure');
  }

  connectedCallback(){
    if (this.mobileBottomFilter) {
      this.mobileBottomFilter.addEventListener('click', this.handleFilter.bind(this));
    }

    if (this.mobileBottomSort) {
      this.mobileBottomSort.addEventListener('click', this.handleSorting.bind(this))
    }
  }

  handleFilter(){
    if (this.filterDrawer) {
      this.filterDrawer.setAttribute('open', '');
      this.filterDrawer.classList.add('menu-opening');
    }
  }

  handleSorting(){
    this.classList.add('show-sort-drawer');
    this.closeSortDrawerIcon = this.querySelector(".sort-drawer-close-icon");

    if (this.mobileBottomSort) {
      this.closeSortDrawerIcon.addEventListener('click', this.closeSortingDrawer.bind(this));
    }
  }

  closeSortingDrawer(event){
    event.preventDefault();
    this.classList.remove('show-sort-drawer');
  }
}

customElements.define('mobile-sorting', MobileSorting)

// double slider price range
class PriceRangeSlider extends HTMLElement {
  constructor(){
    super();
    this.range = this.querySelector(".range-selected");
    this.rangeInput = this.querySelectorAll(".range-input input");
    this.rangePrice = document.querySelectorAll(".facets__price .field input");
    this.collectionMaxPrice = parseInt(this.dataset.maxPrice);
    this.rangeMin = Math.round(this.collectionMaxPrice * 0.05);
  }

  connectedCallback(){
    this.updateSlider();
    this.attachEventListeners();
  }

  updateSlider(){
    let minRange = parseInt(this.rangeInput[0].value);
    let maxRange = parseInt(this.rangeInput[1].value);

    this.range.style.left = (minRange / this.rangeInput[0].max) * 100 + '%';
    this.range.style.right = 100 - (maxRange / this.rangeInput[1].max) * 100 + '%';
  }

  attachEventListeners() {
    this.rangeInput.forEach((input) => {
      input.addEventListener('input', (e) => this.handleRangeInput(e));
    });

    this.rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => this.handlePriceInput(e));
    });
  }

  updateRange() {
    let minRange = parseInt(this.rangeInput[0].value);
    let maxRange = parseInt(this.rangeInput[1].value);

    this.rangePrice.forEach((priceInput, index) => {
      if (index % 2 === 0) {
        priceInput.value = minRange
      }
      else {
        priceInput.value = maxRange
      }
    })

    this.range.style.left = (minRange / this.rangeInput[0].max) * 100 + '%';
    this.range.style.right = 100 - (maxRange / this.rangeInput[1].max) * 100 + '%';
  }

  handleRangeInput(e) {
    let minRange = parseInt(this.rangeInput[0].value);
    let maxRange = parseInt(this.rangeInput[1].value);

    if (maxRange - minRange < this.rangeMin) {
      if (e.target.className === 'min') {
        this.rangeInput[0].value = maxRange - this.rangeMin;
      } else {
        this.rangeInput[1].value = minRange + this.rangeMin;
      }
    } else {
      this.updateRange();
    }
  }

  handlePriceInput(e) {
    let minPrice = parseInt(this.rangePrice[0].value);
    let maxPrice = parseInt(this.rangePrice[1].value);

    if (Number.isNaN(minPrice)) {
      minPrice = 0;
    }
    else if(Number.isNaN(maxPrice)){
      maxPrice = this.collectionMaxPrice;
    }

    if (e.target.name == "filter.v.price.gte") {
      minPrice = parseInt(e.target.value);
    }
    else if (e.target.name === "filter.v.price.lte") {
      maxPrice = parseInt(e.target.value);
    }

   if (minPrice <= maxPrice) {
      if (e.target.name === 'filter.v.price.gte') {
        if(minPrice >= 0) {
          this.rangeInput[0].value = minPrice;
        }
        else {
          this.rangeInput[0].value = 0;
        }
      } else {
        if (maxPrice <= this.collectionMaxPrice) {
          this.rangeInput[1].value = maxPrice
        }
        else {
          this.rangeInput[1].value = this.collectionMaxPrice;
        }
      }
      this.updateRange();
   }
  }
}

customElements.define('price-range-slider', PriceRangeSlider);


class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.handleInfiniteScrolling();
    this.displayProductGallery();
  }

  async handleInfiniteScrolling(){
    this.productList = this.querySelector("#product-grid");
    this.infiniteScrollingContainer = this.querySelector(".product-grid-infinite-scrolling");
    if (this.infiniteScrollingContainer) {
      this.loadMoreContainer = this.infiniteScrollingContainer.querySelector(".load-more-container");
      this.currentPage = parseInt(this.infiniteScrollingContainer.dataset.currentPage);
      this.totalPages = parseInt(this.infiniteScrollingContainer.dataset.totalPages);
      this.nextPageUrl = this.infiniteScrollingContainer.dataset.nextPage;
      this.isFetching = false;
      this.printOosProducts = true;
      this.printFirstEight = true;
      this.isAvailibilityFilter = window.location.href.includes("filter.v.availability=1") || window.location.href.includes("filter.v.availability=0");
      this.firsteightProductCard = this.infiniteScrollingContainer.querySelectorAll(".product-grid__item");
      this.productsPerpage = parseInt(this.getAttribute("data-products-perpage")) || 8;

      // Banner and promo carousel blocks are rendered inline by Liquid at their
      // configured grid slot, but printProducts() re-appends every product card,
      // which would strand them at the top. Snapshot them so they can be put back
      // after each render. Both block types carry data-display-position, so they
      // share one selector and one repositioning pass.
      this.gridInsertItems = Array.from(
        this.productList.querySelectorAll(".collection-banner-item, .promo-carousel-item")
      )
        .map((el) => ({ el, position: parseInt(el.dataset.displayPosition, 10) }))
        .filter(({ position }) => Number.isInteger(position) && position > 0)
        .sort((a, b) => a.position - b.position);

      if (!window.location.href.includes("filter.v.availability=0") && this.totalPages > 1) {
        for (let i = 0; i < this.productsPerpage; i++) {
          const item = this.firsteightProductCard[i];
          if (item.classList.contains("unavailable-product")) {
            item.classList.add("hidden");
          }
        }
      }

      //printing first 8 products 
      if (this.totalPages > 1 && this.printFirstEight) {
        this.printFirstEight = false;
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set("filter.v.availability", "1");
        if (window.location.href.includes("filter.v.availability=0")) {
         newUrl.searchParams.set("filter.v.availability", "0");
        }
        newUrl.searchParams.set("page", `1`);
        await this.printProducts(newUrl);
      
      }

      window.addEventListener("scroll", () => this.onScroll());
    }
  }

  async loadMoreProducts() {
    this.url = new URL(this.nextPageUrl, window.location.origin);

    if (!this.isAvailibilityFilter) {
      this.url.searchParams.set("filter.v.availability", "1");
    }

    if (!this.nextPageUrl && this.printOosProducts && !this.isAvailibilityFilter ) {
      this.printAllOosProducts()
    }
    if (this.isFetching || !this.nextPageUrl || this.currentPage >= this.totalPages) return;
    
    this.isFetching = true;
    this.loadMoreContainer.classList.remove('hide-loader');
    
    if (this.printOosProducts) { // To prevent double print
      await this.printProducts();
    }
  }

 //print OOs products
  async printAllOosProducts() {
    this.printOosProducts=false;
    this.loadMoreContainer.classList.remove('hide-loader');
    let newUrl = new URL(window.location.href)
    newUrl.searchParams.set("filter.v.availability", "0");
    for(let i=1;i<=this.totalPages;i++) {
      newUrl.searchParams.set("page", `${i}`);
      await this.printProducts(newUrl);
    }
    this.loadMoreContainer.classList.add('hide-loader');
    this.url = new URL(this.nextPageUrl, window.location.origin);
  }

  async printProducts(url=this.url) {
    try {
      const response = await fetch(url.toString());
      const text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, "text/html");
      const newProducts = newDocument.querySelectorAll("#product-grid .product-grid__item");

      //if no more products are there then print Oos product at last
      if (newProducts.length==0 && this.printOosProducts) { 
        this.printAllOosProducts();
      }
      newProducts.forEach(product => {
        let productId = product.getAttribute("data-product-id")
        this.infiniteScrollingContainer.querySelector(`.product-grid__item[data-product-id='${productId}']`)?.remove();
        this.productList.appendChild(product);
      });

      this.loadMoreContainer.classList.add('hide-loader');

      const newPagination = newDocument.querySelector(".product-grid-infinite-scrolling");

      if (newPagination) {
        this.nextPageUrl = newPagination.dataset.nextPage;
        this.currentPage = parseInt(newPagination.dataset.currentPage);
      }

    } catch (error) {
      console.error("Error loading more products:", error);
    }

    this.isFetching = false;

    this.repositionGridInserts();
    this.displayProductGallery();
  }

  // Move each banner / promo carousel back to its configured grid slot. They are
  // inserted in ascending position order so earlier ones shift the later slots,
  // matching the Liquid layout. Hidden (out-of-stock) cards occupy no visual cell,
  // so they are skipped when counting slots.
  repositionGridInserts() {
    if (!this.gridInsertItems || !this.gridInsertItems.length) return;

    this.gridInsertItems.forEach(({ el }) => el.remove());

    this.gridInsertItems.forEach(({ el, position }) => {
      let slot = 0;
      let anchor = null;

      for (const child of this.productList.children) {
        if (child.classList.contains("hidden")) continue;
        slot += 1;
        if (slot === position) {
          anchor = child;
          break;
        }
      }

      if (anchor) {
        this.productList.insertBefore(el, anchor);
      } else {
        this.productList.appendChild(el);
      }
    });
  }

  displayProductGallery(){
    const cardImageViewWrapper = document.querySelector(".product-image-view-overlay");
    if (cardImageViewWrapper) {
      const cardImageView = document.querySelector(".product-image-view");
      const cardImageViewButton = document.querySelectorAll(".card-image-view");
      const loader = document.querySelector(".image-loader");
      let splideInstance = null;

      if (!cardImageViewButton.length || !cardImageViewWrapper) return;

      const createSplideSlider = () => {
        const slider = document.createElement("div");
        slider.classList.add("imageview-slider", "splide");
        slider.innerHTML = `
          <div class="splide__track">
            <ul class="splide__list"></ul>
          </div>
        `;
        return slider;
      };

      cardImageViewButton.forEach((item) => {
        item.addEventListener("click", async (event) => {
          event.preventDefault();
          cardImageViewWrapper.classList.remove("hidden");
          const productHandle = item.getAttribute("data-product-handle");

          try {
            const response = await fetch(`/products/${productHandle}.json`);
            const data = await response.json();

            if (!data.product || !data.product.images.length) {
              cardImageView.innerHTML = "<p>No images available</p>";
              return;
            }

            const targetDiv = createSplideSlider();
            const splideList = targetDiv.querySelector(".splide__list");

            data.product.images.forEach(image => {
              const liElement = document.createElement("li");
              liElement.classList.add("splide__slide");
              liElement.innerHTML = `<img src="${image.src}" alt="${data.product.title}">`;
              splideList.appendChild(liElement);
            });

            if (splideInstance) splideInstance.destroy(true);

            cardImageView.innerHTML = "";
            cardImageView.appendChild(targetDiv);

            splideInstance = new Splide(targetDiv, {
              type: "slide",
              perPage: 1,
              perMove: 1,
              gap: "1rem",
              arrows: true,
              pagination: true,
              autoplay: false,
            }).mount();
            
          } catch (error) {
            console.error("Error fetching product images:", error);
            cardImageView.innerHTML = "<p>Failed to load images</p>";
          }
        });
      });

      const closeButton = document.querySelector(".product-image-view-close");
      if (closeButton) {
        closeButton.addEventListener("click", () => closeImageView());
      }
    
      cardImageViewWrapper.addEventListener("click", function (event) {
        if (!cardImageView.contains(event.target)) {
          closeImageView();
        }
      });

      function closeImageView() {
        cardImageViewWrapper.classList.add("hidden");
        cardImageView.innerHTML = "";
        if (loader) cardImageView.appendChild(loader.cloneNode(true));
      }
    }
  }

  onScroll() {
    const lastProduct = this.productList.lastElementChild;
    if (!lastProduct) return;

    const lastProductOffset = lastProduct.getBoundingClientRect().bottom + window.scrollY;
    const pageOffset = window.innerHeight + window.scrollY;

    if (pageOffset >= lastProductOffset - 1000) {
      this.loadMoreProducts();
    }
  }
}

customElements.define("product-grid", ProductGrid);

class CustomTagFilters extends HTMLElement {
  constructor() {
    super();
    this.collectionHandle = this.dataset.collectionHandle;
    this.productGrid = document.querySelector(".facets-product-grid-wrapper");
    this.filterTags = this.querySelectorAll(".tag-filters__item");
  }

  connectedCallback() {
    if (this.filterTags.length > 0) {
      this.filterTags.forEach((eachFilter) => {
        eachFilter.addEventListener("click", this.filterProductGrid.bind(this));
      });
    }
  }

  async filterProductGrid(event) {
    this.addDatalayerEvents(event);
    let loader = document.querySelector(".global-loader");

    if (loader) {
      loader.classList.remove("hidden");
    }

    const filterTag = event.target.dataset.filterTagName;
    if (!filterTag) return;

    const tagFilterUrl = `/collections/${this.collectionHandle}/${filterTag}`;

    try {
      const response = await fetch(tagFilterUrl);
      if (!response.ok) throw new Error("Failed to fetch filtered products");

      const text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, "text/html");
      const newProductGrid = newDocument.querySelector(".facets-product-grid-wrapper");

      if (this.productGrid && newProductGrid) {
        history.pushState({ filterTag }, "", `/collections/${this.collectionHandle}/${filterTag}`);
        this.productGrid.innerHTML = newProductGrid.innerHTML;
        if (loader) {
          loader.classList.add("hidden");
        }
        updateTagFilterOffset();
        let bannerheight = 0;
        if (document.querySelector(".collection-page-banner")) {
          bannerheight = document.querySelector(".collection-page-banner").offsetHeight;
        } else if (document.querySelector(".quiz__section")) {
          bannerheight = document.querySelector(".quiz__section").offsetHeight;
        }
        if (document.querySelector(".app-strip")) {
          bannerheight+=document.querySelector(".app-strip").offsetHeight;
        }

        window.scrollTo({
          top: bannerheight
        });        
      } else {
        console.warn("Product grid element not found in response.");
      }
    } catch (error) {
      console.error("Error fetching tag-based products:", error);
    }
  }

  addDatalayerEvents(event){
    let cartValue = 0;
    if (document.querySelector(".cart-discounted-price")) {
      cartValue = document.querySelector(".cart-discounted-price").textContent;
    }

    const clevertapData = {
      Collection_Name : event.target.getAttribute("data-collection-name"),
      Previous_Page : document.referrer,
      Cart_Qty: event.target.getAttribute("data-cart-qty"),
      Cart_Value: cartValue,
    }

    dataLayer.push({
      event: "Collection_Filter_Name",
      Collection_Name : event.target.getAttribute("data-collection-name"),
      Previous_Page : document.referrer,
      Cart_Qty: event.target.getAttribute("data-cart-qty"),
      Cart_Value: cartValue,
      clevertap: clevertapData
    });
  }
}

customElements.define("custom-tag-filters", CustomTagFilters);


function updateTagFilterOffset() {
  const header = document.querySelector('.site-header');
  const tagFilter = document.querySelector('custom-tag-filters');

  if (header && tagFilter) {
    const headerHeight = header.offsetHeight;
    tagFilter.style.top = `${headerHeight-1}px`;
  }
}

// Run on DOM load and window resize
document.addEventListener('DOMContentLoaded', updateTagFilterOffset);
window.addEventListener('resize', updateTagFilterOffset);

const header = document.querySelector('.site-header');
const tagFiltersObserver = new ResizeObserver(updateTagFilterOffset);

if (header) tagFiltersObserver.observe(header);